import { Base } from "./base";

export class UserRole extends Base {
  /**
   * @description List Sublocation API function
   * @param {object} filterParams
   * @param {?string} filterParams.location Location ID associated with the sublocation
   * @returns {Promise<Response>}
   */
  list(filterParams) {
    const url = new URL(this._getFullURL("/user-role"));
    url.search = new URLSearchParams(filterParams).toString();
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Create Sublocation API function
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  create(payload) {
    const url = this._getFullURL("/user-role");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      }),
    );
  }

  update(uid, payload) {
    const url = this._getFullURL("/user-role/" + uid);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "PUT",
      }),
    );
  }

  delete = (uid) => {
    const url = this._getFullURL(`/user-role/${uid}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      }),
    );
  };
}
